import React from 'react'
import PropTypes from 'prop-types'
import {
  COLORS,
  HEADING_TYPE,
  BUTTON_SIZE,
  BUTTON_TYPE,
  TEXT_SIZES,
  DIVIDER_SIZE,
} from '@helpers/constants'
import { SchoolClassCardStyle } from './style'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Button from '@components/Button'
import Icon from '@components/Icon'
import Divider from '@components/Divider'
import { useConfirmRemoveDemoSchoolClass } from '@hooks/useConfirmRemoveDemoSchoolClass'

const DemoSchoolClassCard = (props) => {
  const { schoolClass } = props
  const { id, name, students, books } = schoolClass
  const { confirmRemoveDemoSchoolClass } = useConfirmRemoveDemoSchoolClass(schoolClass)

  return (
    <div className={SchoolClassCardStyle.container}>
      <div>
        <Heading
          size={TEXT_SIZES.LARGE}
          headingLevel={HEADING_TYPE.H2}
          color={COLORS.DEMO_GREEN.TEXT}
        >
          {name}
        </Heading>
      </div>

      <div className={'absolute bg-demoGreen top-4 right-[-.5rem] py-2 px-4'}>
        <p className='text-xxSmall'>
          demo
        </p>
      </div>

      <Divider size={DIVIDER_SIZE.SMALL} />

      <div className={'flex justify-between items-end'}>
        <div>
          <div className={'flex items-center text-white'}>
            <Icon icon={'Classes'} />
            <Text
              size={TEXT_SIZES.XXSMALL}
              color={'text-white'}
              extraClasses={'pl-2'}
            >
              Elever: {students?.length}
            </Text>
          </div>

          <div className={'flex items-center text-white'}>
            <Icon icon={'Book'} />
            <Text
              size={TEXT_SIZES.XXSMALL}
              color={'text-white'}
              extraClasses={'pl-2'}
            >
              Delade böcker: {books?.length}
            </Text>
          </div>
        </div>

        <div className={'flex'}>
          <Button
            type={BUTTON_TYPE.DARK_GREY}
            size={BUTTON_SIZE.MEDIUM}
            to={`/demoklass/${id}`}
            margin
          >
            Visa klass
          </Button>

          <Button
            type={BUTTON_TYPE.DARK_GREY}
            size={BUTTON_SIZE.ICON_CIRCLE}
            handleClick={confirmRemoveDemoSchoolClass}
            icon={'Exit'}
          />
        </div>
      </div>
    </div>
  )
}

DemoSchoolClassCard.propTypes = {
  schoolClass: PropTypes.object,
  size: PropTypes.string,
}

export default DemoSchoolClassCard
